import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { HelpTooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { CellParamsDef } from '@grnhse/seedling/lib/birch/components/table';
import TagsCell from 'talent_matching/components/shared/tags_cell';
import LatestApplicationHistoryCell from 'talent_matching/talent_rediscovery/components/table/latest_application_history_cell'; // eslint-disable-line max-len
import RediscoveryActivityCell from 'talent_matching/talent_rediscovery/components/table/rediscovery_activity_cell';
import RediscoveryCandidateCell from 'talent_matching/talent_rediscovery/components/table/rediscovery_candidate_cell';
import RediscoveryRowActions from 'talent_matching/talent_rediscovery/components/table/rediscovery_row_actions';
import SummaryCell from 'talent_matching/talent_rediscovery/components/table/summary_cell';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { withLocalePrefix } from 'shared/utils/translation';
import { ACTIONS_COLUMN_FIELD } from 'talent_matching/hooks/use_column_visibility';

const t = withLocalePrefix('talent_matching.rediscovery.table.columns');

type ColumnsOptions = {
  userDateFormat: string;
};

const RediscoveryTagsCell = ({ applicationId }: { applicationId: number }) => {
  const { application } = useRediscoveryApplication(applicationId);

  return <TagsCell tags={application?.tags} />;
};

export const useRediscoveryColumns = ({ userDateFormat }: ColumnsOptions) => {
  return [
    {
      field: 'fullName',
      headerName: t('candidate'),
      minWidth: 250,
      cell: (params: CellParamsDef) => {
        return <RediscoveryCandidateCell applicationId={params.row.id} />;
      },
    },
    {
      field: 'latestApplicationHistory',
      headerName: t('latest_application_history'),
      minWidth: 250,
      cell: (params: CellParamsDef) => {
        return (
          <LatestApplicationHistoryCell
            applicationId={params.row.id}
            userDateFormat={userDateFormat}
          />
        );
      },
    },
    {
      field: 'summary',
      headerName: t('summary'),
      minWidth: 250,
      cell: (params: CellParamsDef) => {
        return <SummaryCell applicationId={params.row.id} />;
      },
    },
    {
      field: 'rediscovery_activity',
      headerName: t('rediscovery_activity'),
      minWidth: 250,
      renderHeader: () => (
        <Stack direction="row" spacing={1}>
          <SecondaryBody medium>{t('rediscovery_activity')}</SecondaryBody>
          <HelpTooltip
            ariaLabel={t('rediscovery_activity_tooltip')}
            label={t('rediscovery_activity_tooltip')}
          ></HelpTooltip>
        </Stack>
      ),
      cell: (params: CellParamsDef) => {
        return <RediscoveryActivityCell applicationId={params.row.id} />;
      },
    },
    {
      field: 'tags',
      headerName: t('tags'),
      minWidth: 200,
      cell: (params: CellParamsDef) => {
        return <RediscoveryTagsCell applicationId={params.row.id} />;
      },
    },
    {
      field: ACTIONS_COLUMN_FIELD,
      headerName: '',
      width: 60,
      sortable: false,
      resizable: false,
      disableColumnMenu: true,
      cell: (params: CellParamsDef) => {
        return <RediscoveryRowActions applicationId={params.row.id} />;
      },
    },
  ];
};
